import * as Action from '../action';
import * as Constant from '../../constant';

const initialState = {
  downloading: false,
  uploading: false,
  deleting: false,

  dialogAddStatus: false,
  dialogEditStatus: false,
  dialogDetailStatus: false,
  dialogDeleteStatus: false,

  selectedFormId: '',

  filters: {
    [Constant.TABLE_FIELD_FORM_TITLE]: '',
    [Constant.RXFIELD_FIELD_FORM]: '',
  },
  sortField: '',
  sortDirection: '',
  activePage: 0,
  pageSize: 20,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.DOWNLOADING_FORM:
      return { ...state, downloading: action.value };
    case Action.UPLOADING_FORM:
      return { ...state, uploading: action.value };
    case Action.DELETING_FORM:
      return { ...state, deleting: action.value };
    case Action.SET_FORM_SELECTED_ID:
      return { ...state, selectedFormId: action.value };
    case Action.SET_FORM_ADD_DIALOG_STATUS:
      return { ...state, dialogAddStatus: action.value };
    case Action.SET_FORM_EDIT_DIALOG_STATUS:
      return { ...state, dialogEditStatus: action.value };
    case Action.SET_FORM_DETAIL_DIALOG_STATUS:
      return { ...state, dialogDetailStatus: action.value };
    case Action.SET_FORM_DELETE_DIALOG_STATUS:
      return { ...state, dialogDeleteStatus: action.value };
    case Action.SET_FORM_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.value,
        },
      };
    }
    case Action.SET_FORM_PAGING: {
      return { ...state, ...action.value };
    }
    case Action.SET_FORM_SORT: {
      return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
    }
    default:
      return state;
  }
};
